import React from 'react';
import { SparklesIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { Link } from 'react-router-dom';

interface UpgradePromptProps {
  feature: string;
  description?: string;
}

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({
  feature,
  description = 'Upgrade to Pro to unlock this feature and supercharge your productivity.',
}) => {
  const { subscribe } = useSubscription();

  return (
    <div className="relative rounded-2xl border border-border bg-card/50 p-8 sm:p-12 text-center">
      <div className="flex justify-center mb-4">
        <div className="p-3 rounded-full bg-primary/10">
          <LockClosedIcon className="w-8 h-8 text-primary" />
        </div>
      </div>
      <h3 className="text-xl font-bold">{feature}</h3>
      <p className="text-muted-foreground mt-2 max-w-md mx-auto">{description}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
        <Button onClick={subscribe} className="gap-2">
          <SparklesIcon className="w-4 h-4" />
          Upgrade to Pro — $9.99/mo
        </Button>
        <Button variant="ghost" asChild>
          <Link to="/pricing">See all features</Link>
        </Button>
      </div>
    </div>
  );
};
